/* eslint-disable react/prop-types */
import React from "react"
import BodyText from "../text/body-text/body-text"
import { PiCopyThin } from "react-icons/pi"
import { useToast } from "../toast/ToastContext"

const LisCenterBox = ({ name, address, email, phone }) => {
  const {showToast} = useToast() || {};
  const copyText = ({ text }) => {
    navigator.clipboard.writeText(text)
    if(showToast){
      showToast("Copied To Clipboard", "info")
    }
  }

  return (
    <div>
      {name && (
        <div>
          <BodyText variant="bodyText6" className="font-bold">
            {name}
          </BodyText>
        </div>
      )}
      {address && (
        <div >
            <div className="flex items-center gap-2">
              <BodyText variant="bodyText7">{address}</BodyText>
              <button
                onClick={() => copyText({ text: address })}
                className="text-[#4559ED]"
              >
                <PiCopyThin />
              </button>
            </div>
        </div>
      )}
      {email && (
        <div className="flex">
          <BodyText variant="bodyText7" className="font-bold pr-2">
            Email:
          </BodyText>
          <div className="flex gap-2 items-center">
            <BodyText variant="bodyText7">{email}</BodyText>
            <button
              onClick={() => copyText({ text: email })}
              className="text-[#4559ED]"
            >
              <PiCopyThin />
            </button>
          </div>
        </div>
      )}
      {phone && (
        <div className="flex">
          <BodyText variant="bodyText7" className="font-bold pr-2">
            Tel:
          </BodyText>
          <div className="flex gap-2 items-center">
            <BodyText variant="bodyText7">{phone}</BodyText>
            <button
              onClick={() => copyText({ text: phone })}
              className="text-[#4559ED]"
            >
              <PiCopyThin />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default LisCenterBox
